import { render } from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=template&id=0847aa3e"
import script from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=script&lang=js"
export * from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__